import Cookies from "universal-cookie";

export const REFRESH_KEY = "hoda-refresh";
export const ACCESS_KEY = "hoda-access";

export const getTokens = () => {
  const { cookies } = new Cookies(document.cookie);
  return cookies ? { refresh: cookies[REFRESH_KEY], access: cookies[ACCESS_KEY] } : {};
};

export const convertCookies = (data) => {
  if (data) {
    switch (data) {
      case "undefined":
        return undefined;
      case "null":
        return null;
      case "true":
        return true;
      case "false":
        return false;
      default:
        return data;
    }
  }
  return undefined;
};
